import { useFieldArray, useFormContext } from "react-hook-form";
import { useEditorHistoryContextOptional } from "../contexts/editor-history-context";
import type { Block, BlockEditorFormValues, Section } from "../types";
import { useEditorSelectedBlock } from "../contexts/editor-selected-block-context";


export function useInsertBlock() {
	const { control } = useFormContext<BlockEditorFormValues>();
  const history = useEditorHistoryContextOptional();
	const { setSelectedBlock } = useEditorSelectedBlock();

	const beforeArray = useFieldArray({
		control,
		name: "content.beforeBlocks",
		keyName: "fieldId",
	});

	const insideArray = useFieldArray({
		control,
		name: "content.insideBlocks",
		keyName: "fieldId",
	});

	const afterArray = useFieldArray({
		control,
		name: "content.afterBlocks",
		keyName: "fieldId",
	});

	const insertBlock = (
		section: Section,
		index: number,
		block: Omit<Block, "id">,
	) => {
		const newBlock = { ...block, id: crypto.randomUUID() } as Block;

		switch (section) {
			case "before":
				beforeArray.insert(index, newBlock);
				setSelectedBlock(newBlock);
				break;
			case "inside":
				insideArray.insert(index, newBlock);
				setSelectedBlock(newBlock);
				break;
			case "after":
				afterArray.insert(index, newBlock);
				setSelectedBlock(newBlock);
				break;
			default:
				console.error("Invalid section:", section);
		}

    // Capture state AFTER the insert operation
    setTimeout(() => history?.captureState(), 0);
	};

	const appendBlock = (section: Section, block: Omit<Block, "id">) => {
		const newBlock = { ...block, id: crypto.randomUUID() } as Block;

		switch (section) {
			case "before":
				beforeArray.append(newBlock);
				break;
			case "inside":
				insideArray.append(newBlock);
				break;
			case "after":
				afterArray.append(newBlock);
				break;
			default:
				console.error("Invalid section for append:", section);
		}

    // Capture state AFTER the append operation
    setTimeout(() => history?.captureState(), 0);
	};

	return { insertBlock, appendBlock };
}
